/**
 * Pdf portal
 * Portal to generate PDF and handle authentication.
 *
 * OpenAPI spec version: 1.0.32
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Section } from './section';
import { StemReportCategoryResult } from './stemReportCategoryResult';

/**
 * Base class serializer for all OpenAPI serializers.  It only implements create/update method without any logic to prevent \"abstract\" warning by pylint.
 */
export interface StemReportTestData { 
    id: number;
    uuid: string;
    childUuid: string;
    testId: number;
    testUuid: string;
    status: string;
    startedAt: Date;
    finishedAt: Date;
    notes: Array<Section>;
    categoryResults: StemReportCategoryResult;
}